import { useState } from 'react';
import { AdminDemoData } from '@platform/client';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';

export const CreateDemoJobPostingModal = (props: { onClose: () => void }) => {
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const [successText, setSuccessText] = useState<string>();

  const createJobPostingMutator = AdminDemoData.useCreateDemoJobPosting({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: (data) => {
        setSuccessText(`Job posting #${data.jobPostingId} ("${data.title}") created.`);
        setModalStage('success');
      },
    },
  });

  return (
    <AdminFormModal
      title='Create Demo Job Posting'
      onClose={props.onClose}
      modalStage={modalStage}
      successText={successText}
      submitCTA={{
        text: 'Create',
        callback: () => createJobPostingMutator.mutate(),
      }}
    >
      <p className='text-sm text-gray-600'>
        Creates a realistic job posting to show off on the community page — no configuration
        needed.
      </p>
    </AdminFormModal>
  );
};
